import { cryptoDecryptData } from './baseQueryWithEncryption';

export const fetchBaseQueryWithEncryption = async (
	url: string,
	options?: {
		apiKey?: string;
		body?: any;
		method?: 'POST' | 'GET' | 'PUT' | 'DELETE' | 'PATCH';
		headers?: Record<string, string>;
	}
): Promise<{
	data: {
		encryptData: string;
		localData?: any;
		decryptedData?: any;
	} | null;
	status: number;
}> => {
	return fetch(url, {
		method: options?.method || 'GET',
		body: options?.body ? JSON.stringify(options?.body) : undefined,
		credentials: 'include',
		headers: {
			...(options?.headers || {}),
		},
	})
		.then(async (response) => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			let result: {
				data: {
					encryptData: string;
					localData?: any;
					decryptedData?: any;
				};
				status: number;
			} = await response.json();
			const innerData = result.data;
			const encryptedData = innerData?.encryptData;
			if (encryptedData && typeof encryptedData === 'string') {
				try {
					const decryptedUtf8 = cryptoDecryptData(encryptedData);
					if (!decryptedUtf8) {
						return result;
					}

					let decryptedParsed: any = decryptedUtf8;
					try {
						decryptedParsed = JSON.parse(decryptedUtf8);
					} catch {
						// keep as string if not JSON
					}

					result = {
						...result,
						data: {
							encryptData: encryptedData,
							decryptedData: decryptedParsed,
							localData: decryptedParsed,
						},
					};
				} catch (error) {
					console.log('error in decryption', error);
					// leave original data if decryption fails
				}
			}
			return result;
		})
		.catch((error) => {
			console.error('Failed to fetch data:', error);
			throw error;
		});
};
